import { render, staticRenderFns } from "./gdpr-tasks.vue?vue&type=template&id=74e5b8cc"
import script from "./gdpr-tasks.vue?vue&type=script&lang=js"
export * from "./gdpr-tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports